import { render, staticRenderFns } from "./PlotDeleteDialog.vue?vue&type=template&id=224c5c23&scoped=true"
import script from "./PlotDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./PlotDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./PlotDeleteDialog.vue?vue&type=style&index=0&id=224c5c23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224c5c23",
  null
  
)

export default component.exports